import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';
import ProgressBar from '../components/ProgressBar';

const StartPage: React.FC = () => {
  const navigate = useNavigate();
  const { setUserType } = useBooking();

  const handleUserTypeSelect = (type: 'local' | 'foreign') => {
    setUserType(type);
    navigate('/transport-booking');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <ProgressBar currentStep={1} />
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            歡迎來到花蓮數位游牧整合平台
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            讓我們為您量身打造完美的花蓮數位游牧體驗
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white rounded-3xl shadow-soft p-8 mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
              請選擇您的身分
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <button
                onClick={() => handleUserTypeSelect('local')}
                className="group relative overflow-hidden bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-2xl p-8 transition-all duration-300 transform hover:scale-105 hover:shadow-large"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-blue-400 to-blue-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                <div className="relative z-10">
                  <div className="text-4xl mb-4">🇹🇼</div>
                  <h3 className="text-2xl font-bold mb-2">我是台灣旅客</h3>
                  <p className="text-blue-100 text-lg">
                    享受國內旅遊的便利與熟悉感
                  </p>
                </div>
              </button>

              <button
                onClick={() => handleUserTypeSelect('foreign')}
                className="group relative overflow-hidden bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white rounded-2xl p-8 transition-all duration-300 transform hover:scale-105 hover:shadow-large"
              >
                <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-green-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
                <div className="relative z-10">
                  <div className="text-4xl mb-4">🌏</div>
                  <h3 className="text-2xl font-bold mb-2">我是外國旅客</h3>
                  <p className="text-green-100 text-lg">
                    探索台灣東部的自然美景與文化
                  </p>
                </div>
              </button>
            </div>
          </div>

          <div className="text-center">
            <p className="text-gray-500 text-sm">
              選擇身分後，我們將為您提供最適合的服務建議
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPage; 